
<div class="container-loader" *ngIf="isBusy">
    <ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>
</div>
<ng-container *ngIf="jobList">
    <div class="joblist-container" *ngIf="jobList.length > 0; else noItems">
        
        <div  class="swiper-container" [swiper]="config" style="width:100%;padding: 15px 5px;">
            <div class="swiper-wrapper">
                <div class="swiper-slide " *ngFor="let job of jobList" (click)="triggerJob(job.JobId)">
                    <div class="quickAction" (mouseover)="job.IsHover = true" (mouseleave)="job.IsHover = false" [id]="job.JobDisplay">
                        <div class="job-image-container">

                            <ng-container *ngIf="availableImages.indexOf(job.JobDisplay) > -1; else template">
                                <img #image [src]="!job.IsHover ? '../../assets/images/' + job.JobDisplay + 'GREY.png' : '../../assets/images/' + job.JobDisplay + 'WHITE.png'">
                            </ng-container>
                            <ng-template #template>
                                <img #image [src]="!job.IsHover ? '../../assets/images/TEMPLATEGREY.png' : '../../assets/images/TEMPLATEWHITE.png'">
                            </ng-template>

                        </div>
                        <p class="jobName">{{job.JobName}}</p>        
                        <span (click)="pullPopup($event, job)" class="utter-icon pull-right" title="Add Quick Phrase"><i class="fa fa-ellipsis-v"></i></span>
                    </div>
                </div>
            </div>
            
            <div class="swiper-pagination"></div>
        </div>
        
        <button *ngIf="jobList.length > 0" type="button"
            [ngClass]="{'slide-prev swiper-button-prev': true, 'slide-arrow' :true}" 
            aria-label="Previous" 
            role="button" 
            style="display: block;" 
            (click)="prevPage()">Previous</button>
        <button *ngIf="jobList.length > 0" type="button" 
            [ngClass]="{'slide-next swiper-button-next': true, 'slide-arrow': true}" 
            aria-label="Next"
            role="button"
            style="display: block;" 
            (click)="nextPage()">Next</button>
    </div>
    <ng-template #noItems>
        <div class="no-item-container">
            <p>You have not added any quick links.</p>
        </div>
    </ng-template>
</ng-container>
